import BarChartIcon from '@mui/icons-material/BarChart';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import RedeemIcon from '@mui/icons-material/Redeem';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

export const menus = [
    {
        title: 'IGD-M',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardigd/results',
        gap: true
    },
    {
        title: 'Vigilância Socioassistencial',
        icon: <SentimentVeryDissatisfiedIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardigd/SocialAssistanceSurveillance',
    },

    {
        title: 'Beneficios',
        icon: <RedeemIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardigd/Benefits',
    },
    {
        title: 'Cadastro Único',
        icon: <ChildCareIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardigd/cad-unique',
    }
];
